// routes
import AppRoutes from './AppRoutes';
import ScrollToTop from './ScrollToTop';

const Routes = () => {
    return (
        <>
            {/* <AllRoutes /> */}
            <ScrollToTop />
            <AppRoutes />
        </>
    );
};

export default Routes;
